<template>
    <modal ref="modal" :modal-backdrop="true">
        <template #body>
            <div class="text-center">
                <div v-if="appointmentStore.hasNote">
                    <div class="text-gray-700 text-lg">Anotações pendentes</div>
                    <div class="mt-4 mb-4">É necessário salvar ou cancelar as anotações pendentes antes de encerrar a consulta</div>
                </div>
                <div v-if="!appointmentStore.hasNote" class="text-gray-700 text-lg mb-4">Deseja realmente encerrar a consulta?</div>
                <button type="button" class="btn-primary-invert font-normal" @click.prevent="close">Cancelar</button>
                <button v-if="!appointmentStore.hasNote" type="button" class="btn-primary font-normal ml-1" @click.prevent="confirm">Confirmar</button>
            </div>
        </template>
    </modal>
</template>
<script>
import { ref } from 'vue';
import Modal from '@/Shared/Modal/Modal'
import { useAppointmentStore } from '@/Store/Appointment'

export default {
    components: {
        Modal,
    },
    data() {
        return {
            appointmentStore: useAppointmentStore(),
        }
    },
    setup(props, context) {
        const modal = ref(null);
        
        const openModalConfirmHangup = () => {
            modal.value.showModal = true;
        }

        const closeModalConfirmHangup = () => {
            modal.value.showModal = false;
        }

        return {
            openModalConfirmHangup,
            closeModalConfirmHangup,
            modal
        }
    },
    methods: {
        confirm() {
            this.$emit('confirm', this.item);
            this.close();
        },
        open() {
            this.$refs.modal.showModal = true;
        },
        close() {
            this.$refs.modal.showModal = false;
        }
    },
}
</script>
<style>
    
</style>